const MODULE_NAME = "TAGS";
const FETCH_STARTED = MODULE_NAME + 'FETCH_STARTED';
const FETCH_COMPLETED = MODULE_NAME + 'FETCH_COMPLETED';

export {
  FETCH_STARTED,
  FETCH_COMPLETED
};
